module.exports = __webpack_public_path__ + "static/media/book-alt.c756a4d1.svg";